import { useSyncExternalStore } from 'react';

// types
import { SnackbarProps } from 'types/snackbar';

// ==============================|| API - SNACKBAR ||============================== //

const initialState: SnackbarProps = {
  action: false,
  open: false,
  message: 'Note archived',
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'right'
  },
  severity: 'success',
  variant: 'default',
  alert: {
    variant: 'filled'
  },
  transition: 'Fade',
  close: false,
  actionButton: false,
  maxStack: 3,
  dense: false,
  iconVariant: 'usedefault'
};

let snackbarState = initialState;
const listeners = new Set<() => void>();

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function emit() {
  listeners.forEach((listener) => listener());
}

export function useGetSnackbar() {
  const snackbar = useSyncExternalStore(
    subscribe,
    () => snackbarState,
    () => snackbarState
  );

  return { snackbar };
}

export function openSnackbar(snackbar: SnackbarProps) {
  const { action, open, message, anchorOrigin, variant, alert, transition, close, actionButton, severity } = snackbar;

  snackbarState = {
    ...snackbarState,
    action: action || initialState.action,
    open: open || initialState.open,
    message: message || initialState.message,
    anchorOrigin: anchorOrigin || initialState.anchorOrigin,
    variant: variant || initialState.variant,
    severity: severity || initialState.severity,
    alert: { variant: alert?.variant || initialState.alert.variant },
    transition: transition || initialState.transition,
    close: close || initialState.close,
    actionButton: actionButton || initialState.actionButton
  };
  emit();
}

export function closeSnackbar() {
  snackbarState = { ...snackbarState, open: false };
  emit();
}

export function handlerIncrease(maxStack: number) {
  snackbarState = { ...snackbarState, maxStack };
  emit();
}

export function handlerDense(dense: boolean) {
  snackbarState = { ...snackbarState, dense };
  emit();
}

export function handlerIconVariants(iconVariant: string) {
  snackbarState = { ...snackbarState, iconVariant };
  emit();
}
